import React from 'react';
import { useTranslation } from 'react-i18next';
import { COLORS } from '@mafc/common';
import { NowTabIcon, StandardTabIcon } from '@mafc/icon';
import { Box } from '@mafc/trolly';
import colors from '../../../../theme/colors';
import {
  isExpressShipment,
  isFoodShipment,
  isNonFoodShipment,
} from 'pages/NewCart/helpers/shipment.helper';
import * as S from './ShipmentDelivery.style';

const ShipmentDelivery: React.FC<{
  busyHourDisclaimer: string;
  deliveryPromise: string;
  isNowOfflineHour: boolean;
  isNowUnavailableHour: boolean;
  nextAvailableSlot: any;
  shipmentType: string;
  isShipmentOOS: boolean;
}> = ({
  busyHourDisclaimer,
  deliveryPromise = '',
  isNowOfflineHour = false,
  isNowUnavailableHour = true,
  nextAvailableSlot = {},
  shipmentType = '',
  isShipmentOOS,
}) => {
  const { t } = useTranslation();
  const isExpress = isExpressShipment(shipmentType);
  const shipmentKey = isExpress ? 'shipmentCardHeading.now' : 'shipmentCardHeading.standard';
  const isExpressUnavailable = isNowUnavailableHour && isExpress;
  const isStandard = isFoodShipment(shipmentType) || isNonFoodShipment(shipmentType);

  return (
    <S.Delivery isExpressUnavailable={isExpressUnavailable}>
      <S.DeliveryInfo>
        <S.IconWrapper>
          {isExpress ? (
            <NowTabIcon
              size="custom"
              width="32px"
              fill={isExpressUnavailable ? colors.ERROR_RED : COLORS.BLACK}
            />
          ) : (
            <StandardTabIcon size="custom" width="32px" fill={COLORS.BLACK} />
          )}
        </S.IconWrapper>

        {isExpressUnavailable ? (
          <Box>
            <S.DeliveryTypeAndTime>
              <Box as="span">{t('offlineTitle')}</Box> -{' '}
              <Box as="span" sx={{ fontWeight: 'bold' }} color={colors.ERROR_RED}>
                {isNowOfflineHour ? t('offlineClosed') : t('unavailable')}
              </Box>
            </S.DeliveryTypeAndTime>
            <S.DeliveryFee>
              {isNowOfflineHour
                ? t('offlineNextDelivery', {
                    day: nextAvailableSlot.day ? nextAvailableSlot.day.toLowerCase() : '',
                    startTime: nextAvailableSlot.startTime
                      ? nextAvailableSlot.startTime.toUpperCase()
                      : '',
                  })
                : busyHourDisclaimer}
            </S.DeliveryFee>
          </Box>
        ) : (
          <Box>
            <S.DeliveryTypeAndTime>
              {isShipmentOOS
                ? t('outOfStock.itemsOutOfStock')
                : `${t(shipmentKey)} ${deliveryPromise}`}
            </S.DeliveryTypeAndTime>
            {isStandard && (
              <Box as="p" data-testid="delivery-slot-text" fontSize="12px">
                {t('deliverySlotText')}
              </Box>
            )}
            {isExpress && !isShipmentOOS && (
              <Box
                as="p"
                data-testid="now-delivery-time-hint-text"
                fontSize={['10px', null, null, '11px']}
              >
                {t('cartShipment.nowDeliveryTimeHint')}
              </Box>
            )}
            {/* <S.DeliveryFee>{t('delivery')}: AED XXX</S.DeliveryFee> */}
          </Box>
        )}
      </S.DeliveryInfo>

      {/* Change button placement */}
    </S.Delivery>
  );
};

export default ShipmentDelivery;
